import React from "react";
import { makeStyles } from "@material-ui/core";
import { ReactComponent as StarIcon } from "../../../../assets/star.svg";
import { useTranslation } from "react-i18next";
import RadioButton from "../../../../shared/components/RadioButton/RadioButton";

// -----------------------
// Address Type Definition
// -----------------------
export interface Address {
  id: string;
  fullName?: string;
  streetLine1: string;
  streetLine2?: string;
  city?: string;
  postalCode?: string;
  countryCode?: string;
  phoneNumber?: string;
  defaultShippingAddress?: boolean;
  defaultBillingAddress?: boolean;
  latitude: number;
  longitude: number;
}

// -----------------------
// Component Props
// -----------------------
interface SavedAddressesProps {
  addresses: Address[];
  selectedAddress: Address | null;
  onSelect: (address: Address) => void;
}

// -----------------------
// Styles
// -----------------------
const useStyles = makeStyles({
  addressDetails: {
    display: "flex",
    alignItems: "center",
    marginBottom: 24,
  },
  addressDetailsBody: {
    display: "flex",
    flexDirection: "column",
  },
});

// -----------------------
// Component
// -----------------------
const SavedAddresses: React.FC<SavedAddressesProps> = ({
  addresses,
  selectedAddress,
  onSelect,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      {addresses?.length > 0 ? (
        addresses?.map((addr) => (
          <div key={addr.id} className={classes.addressDetails}>
            <RadioButton
              checked={selectedAddress?.id === addr.id}
              onChange={() => onSelect(addr)}
              value={selectedAddress?.id as string}
              name={selectedAddress?.id as string}
            >
              {addr.defaultShippingAddress && (
                <div style={{ marginRight: 8 }}>
                  <StarIcon />
                </div>
              )}

              <div className={classes.addressDetailsBody}>
                <span>{addr.streetLine1}</span>
              </div>
            </RadioButton>
          </div>
        ))
      ) : (
        <span> {t("account.noAdresses")}</span>
      )}
    </div>
  );
};

export default SavedAddresses;
